import { initContract } from '@ts-rest/core';
// File status constants to avoid manual strings
export const FILE_STATUS = {
    UPLOADING: 'uploading',
    EMBEDDING: 'embedding',
    COMPLETED: 'completed',
    ERROR: 'error',
};
export const FILE_VISIBILITY = {
    shown: 'shown',
    hidden: 'hidden',
    unknown: 'unknown',
};
const c = initContract();
export const fileContract = c.router({
    getFile: {
        method: 'GET',
        path: '/files/:id',
        query: c.type(),
        summary: 'Get a file by id',
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    getAllFiles: {
        method: 'GET',
        path: '/files',
        summary: 'Get all files with pagination and filtering',
        query: c.type(),
        responses: {
            200: c.type(),
        },
    },
    getFilesByIds: {
        method: 'POST',
        path: '/files/by-ids',
        summary: 'Get specific files by their IDs',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
        },
    },
    deleteFile: {
        method: 'DELETE',
        path: '/files/:id',
        summary: 'Delete a file by id',
        responses: {
            200: c.type(),
            404: c.type(),
            401: c.type(),
            500: c.type(),
        },
    },
    deleteFiles: {
        method: 'DELETE',
        path: '/files',
        summary: 'Delete multiple files by ids',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            401: c.type(),
            500: c.type(),
        },
    },
    updateFile: {
        method: 'PUT',
        path: '/files/:id',
        summary: 'Update a file name',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            404: c.type(),
            401: c.type(),
        },
    },
    bulkUpdateFiles: {
        method: 'PUT',
        path: '/files',
        summary: 'Bulk update multiple files with entities',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            401: c.type(),
            500: c.type(),
        },
    },
    getPresignedUrls: {
        method: 'POST',
        path: '/files/presigned-urls',
        summary: 'Get presigned URLs for file uploads',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            401: c.type(),
        },
    },
    registerFiles: {
        method: 'POST',
        path: '/files/register',
        summary: 'Register uploaded files in database',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            401: c.type(),
        },
    },
});
//# sourceMappingURL=file.js.map